/*
==========================================
Custom JS for Shareholder page
==========================================
*/

window.addEventListener('DOMContentLoaded',()=>{
  // 同意チェックボタン状態保持
  const agreeTermsChb = document.getElementById('agree_terms'),
    addToCartShareholderProduct = document.querySelector('.c-shareholder-products-course__open-dialog-btn button');

  if (agreeTermsChb) {
    if(localStorage.hasOwnProperty('shareholders_agree_terms')){
      const prevTimestamp = new Date(localStorage.getItem('shareholders_agree_terms'));
      const now = new Date();
      const diffTime = Math.abs(now.getTime() - prevTimestamp.getTime()) / (60*60*1000);
      if(diffTime < 24){
        // 前回アクセスが24時間以内ならチェック
        agreeTermsChb.click()
      }
    }
    agreeTermsChb.addEventListener('change',(e)=>{
      const datetime = new Date();
      if(e.target.checked === true){
        localStorage.setItem('shareholders_agree_terms',datetime );
      }else{
        localStorage.removeItem('shareholders_agree_terms');
      }
    })
  }

  // 会員登録系ボタン 押下時 同意なしの場合のチェック処理
  const signAccountBtns = document.querySelectorAll('#register_shareholders_info,#step_sign_up,#step_login');
  signAccountBtns.forEach(btnElem => {
    btnElem.addEventListener('click',(e)=>{
      if(agreeTermsChb.checked !== true){
        alert("お申込みのご案内同意にチェックをお願い致します。");
        e.preventDefault();
      }
    })
  })

  // 優待商品選択時
  document.querySelectorAll('[name="shareholder_product"]').forEach(chbElem => {
    chbElem.checked = false;
    chbElem.addEventListener('change',(event)=>{
      document.querySelector('.product-card-wrapper.is-selected')?.classList.remove("is-selected");
      const productElem = document.querySelector(`.product-card-wrapper[data-product="${event.target.id}"]`);
      productElem.classList.add("is-selected");
      // 優待品の確定ボタンを活性色に
      addToCartShareholderProduct.classList.remove("is-disabled")
    })
  })
});

// 優待商品の確認ダイアログ表示
const openConfirmationDialog = () => {
  const selectedFormId = document.querySelector('[name="shareholder_product"]:checked')
    ? document.querySelector('[name="shareholder_product"]:checked').value + "-submit-for-shareholder"
    : "";
  const submitFormBtn = document.getElementById(selectedFormId),
    agreeTermsChb = document.getElementById('agree_terms');

  if(agreeTermsChb && agreeTermsChb.checked !== true){
    // 同意なしの場合
    alert("お申込みのご案内同意にチェックをお願い致します。");
    const productDecisionBtn = document.querySelector('.c-shareholder-products-course__submit-btn .c-button');
    productDecisionBtn.setAttribute('disabled',true);
    // 同意チェックした場合、非活性を戻す
    agreeTermsChb.addEventListener('change',(event) => {
      if(event.target.checked){
        productDecisionBtn.removeAttribute('disabled')
      }
    })

    agreeTermsChb.parentNode.parentNode.classList.add("is-error");
    const agreeTerms = document.querySelector('.c-application-information');
    const rect = agreeTerms.getBoundingClientRect();
    let elemtop = rect.top + window.pageYOffset - 10;
    if(window.innerWidth <= 989){
      const header_height = document.getElementById('shopify-section-header').clientHeight;
      elemtop -= header_height;
    }
    setTimeout(()=>{
      window.scrollTo({
        top: elemtop,
        behavior: 'smooth',
      });
    }, 0);
  }else if(submitFormBtn){
    // 購入フォームが選択済みの場合
    const dialog = document.getElementById('shareholder-confirmation-dialog');
    dialog.classList.add("is-open")
    dialog.querySelector('.c-modal__background').addEventListener('click',()=>{
      dialog.classList.remove("is-open")
    })
    dialog.querySelector('.c-modal__cancel-btn').addEventListener('click',()=>{
      dialog.classList.remove("is-open")
    })
    agreeTermsChb.parentNode.parentNode.classList.remove("is-error");
  }else{
    // 購入フォームが未選択の場合
    alert("優待商品を選択してください。")
    agreeTermsChb.parentNode.parentNode.classList.remove("is-error");
  }
}


// 優待商品のフォーム送信
const submitShareholderProduct = () =>{
  const selectedFormId = document.querySelector('[name="shareholder_product"]:checked')
    ? document.querySelector('[name="shareholder_product"]:checked').value + "-submit-for-shareholder"
    : "";
  const submitFormBtn = document.getElementById(selectedFormId);

  fetch('/cart/clear.js', {
    'method': 'GET'
  }).then(() => {
    submitFormBtn.click();
  })

}

// 株主情報入力フォーム 確認画面を生成
const registerStepChange = (e) =>{
  e.preventDefault();
  // 1.入力フォームを非表示(キャンセルボタン押下時はhiddenを外す)
  document.querySelector('.c-shareholders-form__wrapper').setAttribute("hidden",true);

  // 2.確認画面を生成
  let holderNumber = document.getElementById("shareholder-number").value;
  let postNumber = document.getElementById("shareholder-postal-code").value;
  const createConfirmationStep = `
    <div class="c-shareholders-form__confirmation__form-part">
      <label class="c-color__text c-txt--bold c-txt">株主番号</label>
      <div class="c-shareholders-form-confirmation__form-block c-color__text c-txt__reading">
        ${holderNumber}
      </div>
    </div>
    <div class="c-shareholders-form__confirmation__form-part">
      <label class="c-color__text c-txt--bold c-txt">郵便番号（ハイフン不要）</label>
      <div class="c-shareholders-form-confirmation__form-block c-color__text c-txt__reading">
        ${postNumber}
      </div>
    </div>
  `;
  document.querySelectorAll('.c-shareholders-form__confirmation__form-part').forEach(el => {
    console.log(el)
    el.remove()
  })
  document.querySelector('[data-confirmation-content]').insertAdjacentHTML('beforeend',createConfirmationStep);

  // 3.確認画面を表示
  document.querySelector('.c-shareholders-form-confirmation__wrapper').removeAttribute('hidden')
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
}

// 株主情報入力フォーム 確認画面から入力画面に戻る
const registerStepBack = (e)=>{
  e.preventDefault();
  // 1.確認画面を非表示、入力画面を表示
  document.querySelector('.c-shareholders-form-confirmation__wrapper').setAttribute("hidden",true);
  document.querySelector('.c-shareholders-form__wrapper').removeAttribute('hidden');

  // 2.確認画面の入力内容コンテンツを削除
  document.querySelector('.c-shareholders-form-confirmation__form-block').innerHTML = "";
}

// 株主情報入力フォーム 株主情報登録完了画面を生成
const submitShareholderForm = (e)=>{
  e.preventDefault();

  // 2023.4.17時点:フォーム送信成功の程で実装
  e.target.classList.add("is-loading");
  e.target.setAttribute('hidden',true);


  // setTimeout(successSubmitForm, 2000);
}


  // 送信成功画面表示処理
  const successSubmitForm = () =>{
    const successSubmitHTML = `
      <h3 class="title--primary h2 c-txt--bold">株主情報登録完了</h3>
      <div class="c-txt__reading c-color__text c-section-description c-section-description--back-page">
        <p>ログイン中の会員情報に株主情報を登録しました。<br>下の「優待商品の選択に進む」をクリックして、優待品選択へ進んでください。</p>
      </div>
      <div class="c-shareholders-form-confirmation">
        <div class="c-shareholders-form__button c-shareholders-form__button--back-page c-color__text c-txt__reading">
          <a href="javascript:showShareholderPage('/pages/mitani_shareholders')" class="c-button c-button--medium">
          優待商品の選択に進む
            <span class="c-button-icon__wrapper--absolute c-button-icon__wrapper--absolute--after"><svg class="c-icon c-icon__arrow" width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.94577 0L12.8516 4.20502H0V3.20502H10.1484L7.29498 0.759257L7.94577 0Z" fill="#1A1A1A"></path></svg></span>
          </a>
        </div>
      </div>
    `;
    document.querySelector('.c-shareholders-form-confirmation__wrapper').innerHTML = successSubmitHTML;

  }